import { render, staticRenderFns } from "./MakeItem.vue?vue&type=template&id=3d79ed72&scoped=true&"
import script from "./MakeItem.vue?vue&type=script&lang=js&"
export * from "./MakeItem.vue?vue&type=script&lang=js&"
import style0 from "./MakeItem.vue?vue&type=style&index=0&id=3d79ed72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d79ed72",
  null
  
)

export default component.exports